module.exports = __webpack_public_path__ + "img/bgvid.d0e00e98.gif";